import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg4VLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.105 3.5 40.525 24l-19.42 20.5h-3.573l-.08-.16-8.126-9.357-.26-.3L6.93 24l2.137-10.684.26-.3 8.125-9.357.08-.159zm-3.667 34.104 1.949 3.896h.428l10.682-11.278zm-5.586-22.92L9.989 24l1.863 9.315 1.657 1.91-2.512-10.888L10.92 24l.077-.337 2.512-10.889zm4.617 20.021L32.757 25.5H14.345zM14.345 22.5h18.412L16.47 13.294zm3.093-12.104 13.06 7.381L19.814 6.5h-.428z" })
});
export default Svg4VLeft;
